// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from "vue";
import App from "./App";
import router from "./router";
import iView from "iview";
import "iview/dist/styles/iview.css";
import Paginate from "vuejs-paginate"; //For Pagination
import * as dayjs from "dayjs";
import * as isSameOrAfter from "dayjs/plugin/isSameOrAfter"; // import plugin

Vue.use(iView);
Vue.component("paginate", Paginate); //For Pagination

Vue.config.productionTip = false;

dayjs.extend(isSameOrAfter); // use isSameOrAfter plugin

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js